<script setup>
import * as heroIcons from '@heroicons/vue/24/outline'
import {defineProps, ref, onMounted} from 'vue'

const props = defineProps({
  name: String,
})

const isLoaded = ref(false)
const icons = ref(heroIcons)

onMounted(() => {
  isLoaded.value = true
})

</script>

<template>
  <component :is="icons[props.name]" v-if="isLoaded" class="w-4 h-4" />
</template>
